/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Clearfilterbeforehiding4Inputs */

const en_datagrid_clearfilterbeforehiding4 = /** @type {(inputs: Datagrid_Clearfilterbeforehiding4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear a column's filter before hiding it.`)
};

/**
* | output |
* | --- |
* | "Clear a column's filter before hiding it." |
*
* @param {Datagrid_Clearfilterbeforehiding4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_clearfilterbeforehiding4 = /** @type {((inputs?: Datagrid_Clearfilterbeforehiding4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Clearfilterbeforehiding4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_clearfilterbeforehiding4(inputs)
});
export { datagrid_clearfilterbeforehiding4 as "dataGrid_clearFilterBeforeHiding" }